import { getOffersClient } from '@b-stock/fe-core/bstock-next/queries'
import { buildAxiosRequestConfig } from '@b-stock/fe-core/bstock-react'
import type { CreateOfferDto } from '@b-stock/offering-api-client'

import type { GaSessionIdPayload } from '@/helpers/telemetry/gaSessionIds'

export const createOffer = async ({
  accessToken,
  createOfferDto,
  gaSessionIdPayload = {},
}: {
  accessToken: string
  createOfferDto: CreateOfferDto
  gaSessionIdPayload?: GaSessionIdPayload
}) => {
  const client = getOffersClient()

  // GLOB-4954: forward the GA client/session ids as top-level camelCase DTO
  // fields (siblings of offeringId/offer — confirmed on the backend capture
  // branch mg-GLOB-4950-capture-ga-ids). The generated CreateOfferDto type
  // doesn't know these fields yet (client regen follows the backend merge), so
  // we extend the type locally. The caller supplies the payload via
  // useGaSessionIdPayload(), which yields `{}` unless the kill switch is on AND
  // the GA cookies are present; defaulting to `{}` here keeps the DTO identical
  // to before for any caller that doesn't pass one.
  const dtoWithGaIds: CreateOfferDto & GaSessionIdPayload = {
    ...createOfferDto,
    ...gaSessionIdPayload,
  }

  return client.createOffer(
    { createOfferDto: dtoWithGaIds },
    buildAxiosRequestConfig({ accessToken })
  )
}
